

export const CORE_LOAD_MANAGE_SYSTEMS_REQUEST = 'CORE_LOAD_MANAGE_SYSTEMS_REQUEST'
export const CORE_LOAD_MANAGE_SYSTEMS_SUCCESS = 'CORE_LOAD_MANAGE_SYSTEMS_SUCCESS'
export const CORE_LOAD_MANAGE_SYSTEMS_FAILURE = 'CORE_LOAD_MANAGE_SYSTEMS_FAILURE'

export const CORE_LOAD_MANAGE_SYSTEM_REQUEST = 'CORE_LOAD_MANAGE_SYSTEM_REQUEST'
export const CORE_LOAD_MANAGE_SYSTEM_SUCCESS = 'CORE_LOAD_MANAGE_SYSTEM_SUCCESS'
export const CORE_LOAD_MANAGE_SYSTEM_FAILURE = 'CORE_LOAD_MANAGE_SYSTEM_FAILURE'

export const CORE_LOAD_MANAGE_SYSTEM_CREATE_REQUEST = 'CORE_LOAD_MANAGE_SYSTEM_CREATE_REQUEST'
export const CORE_LOAD_MANAGE_SYSTEM_CREATE_SUCCESS = 'CORE_LOAD_MANAGE_SYSTEM_CREATE_SUCCESS'
export const CORE_LOAD_MANAGE_SYSTEM_CREATE_FAILURE = 'CORE_LOAD_MANAGE_SYSTEM_CREATE_FAILURE'

export const CORE_LOAD_MANAGE_SYSTEM_UPDATE_REQUEST = 'CORE_LOAD_MANAGE_SYSTEM_UPDATE_REQUEST'
export const CORE_LOAD_MANAGE_SYSTEM_UPDATE_SUCCESS = 'CORE_LOAD_MANAGE_SYSTEM_UPDATE_SUCCESS'
export const CORE_LOAD_MANAGE_SYSTEM_UPDATE_FAILURE = 'CORE_LOAD_MANAGE_SYSTEM_UPDATE_FAILURE'

export const CORE_LOAD_MANAGE_SYSTEM_DELETE_REQUEST = 'CORE_LOAD_MANAGE_SYSTEM_DELETE_REQUEST'
export const CORE_LOAD_MANAGE_SYSTEM_DELETE_SUCCESS = 'CORE_LOAD_MANAGE_SYSTEM_DELETE_SUCCESS'
export const CORE_LOAD_MANAGE_SYSTEM_DELETE_FAILURE = 'CORE_LOAD_MANAGE_SYSTEM_DELETE_FAILURE'


export const CORE_LOAD_MANAGE_GROUPS_REQUEST = 'CORE_LOAD_MANAGE_GROUPS_REQUEST'
export const CORE_LOAD_MANAGE_GROUPS_SUCCESS = 'CORE_LOAD_MANAGE_GROUPS_SUCCESS'
export const CORE_LOAD_MANAGE_GROUPS_FAILURE = 'CORE_LOAD_MANAGE_GROUPS_FAILURE'

export const CORE_LOAD_MANAGE_GROUP_REQUEST = 'CORE_LOAD_MANAGE_GROUP_REQUEST'
export const CORE_LOAD_MANAGE_GROUP_SUCCESS = 'CORE_LOAD_MANAGE_GROUP_SUCCESS'
export const CORE_LOAD_MANAGE_GROUP_FAILURE = 'CORE_LOAD_MANAGE_GROUP_FAILURE'

export const CORE_LOAD_MANAGE_GROUP_CREATE_REQUEST = 'CORE_LOAD_MANAGE_GROUP_CREATE_REQUEST'
export const CORE_LOAD_MANAGE_GROUP_CREATE_SUCCESS = 'CORE_LOAD_MANAGE_GROUP_CREATE_SUCCESS'
export const CORE_LOAD_MANAGE_GROUP_CREATE_FAILURE = 'CORE_LOAD_MANAGE_GROUP_CREATE_FAILURE'

export const CORE_LOAD_MANAGE_GROUP_UPDATE_REQUEST = 'CORE_LOAD_MANAGE_GROUP_UPDATE_REQUEST'
export const CORE_LOAD_MANAGE_GROUP_UPDATE_SUCCESS = 'CORE_LOAD_MANAGE_GROUP_UPDATE_SUCCESS'
export const CORE_LOAD_MANAGE_GROUP_UPDATE_FAILURE = 'CORE_LOAD_MANAGE_GROUP_UPDATE_FAILURE'

export const CORE_LOAD_MANAGE_GROUP_DELETE_REQUEST = 'CORE_LOAD_MANAGE_GROUP_DELETE_REQUEST'
export const CORE_LOAD_MANAGE_GROUP_DELETE_SUCCESS = 'CORE_LOAD_MANAGE_GROUP_DELETE_SUCCESS'
export const CORE_LOAD_MANAGE_GROUP_DELETE_FAILURE = 'CORE_LOAD_MANAGE_GROUP_DELETE_FAILURE'



// WEBPACK FOOTER //
// ./src/app/redux/manageTypes.js